import React from 'react';
import {  StyledAvatar, TextOverflowTooltip } from 'src/common';
import { getProfileCredentials } from 'src/utils/auth';
import { getAvatarColor } from 'src/utils/avatarColor';
import { useTheme } from 'styled-components';
import * as S from './AccessAvatar.styles';

interface AccessAvatarProps {
  name: string;
  imgUrl?: string | null;
  gradientBlue?: boolean;
  /** Tree nesting level (1-based). Used to determine avatar color. */
  level?: number;
  /** Whether this is a workspace (W) or organisation (O) */
  isWorkspace?: boolean;
}

export const AccessAvatar: React.FC<AccessAvatarProps> = ({ name, imgUrl, gradientBlue, level, isWorkspace }) => {
  const colors = useTheme().colors;

  const avatarBgColor =
    level !== undefined && isWorkspace !== undefined ? getAvatarColor({ colors, isWorkspace, level }) : undefined;

  const useGradientBlue = !avatarBgColor && (gradientBlue ?? isWorkspace);

  return (
    <S.Div>
      <StyledAvatar $small $xsmall src={imgUrl || ''} $gradientBlue={useGradientBlue} $bgColor={avatarBgColor}>
        {getProfileCredentials(name)}
      </StyledAvatar>
      <TextOverflowTooltip>
        <span>{name}</span>
      </TextOverflowTooltip>
    </S.Div>
  );
};
